import { Page } from "@/models/page-models/Page";

export const SalesDashboard: Page = {
  "path": "sales-dashboard",
  "name": "Sales Dashboard",
  "props": {
    "data": {
      "title": "Dashboard",
      "printable": "FALSE",
      "url": "sales-dashboard",
      "groups": [
        {
          "type": "popupGroup",
          "label": "Reject Quotation",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.rejectionForm.rejectionReason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE",
                  "items": "fetchedData.qtRejectionReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "printable": false,
                  "multiple": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.otherRejectionReason",
                  "label": "Please elaborate",
                  "showIf": "fn(INCLUDE_ARRAY,{{fetchedData.rejectionForm.rejectionReason}},Other)",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "itemVariable": "fetchedData.selectedQuotation",
          "popupActions": [
            {
              "label": "Confirm",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "rejectQoutation"
                },
                {
                  "executionOrder": 2,
                  "name": "closeRejectionPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Reject Complaint",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.reason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "itemVariable": "fetchedData.selectedComplaint",      
          "popupActions": [
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectComplaint",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/mark-rejected",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rejectionForm",
                    "arg3Key": "requestMethod",
                    "arg3Value": "PATCH",
                    "arg4Key": "fnsAfterSubmit",
                    "arg4Value": "getPendingComplaints"
                  },
                  "name": "rejectComplaint"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Complaint"
                  },
                  "name": "closeRejectionPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "QT",
              "bracketValueFormula": "{{fetchedData.pendingQts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending QT",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingQts.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "QT",
                          "type": "custom-url",
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openEditView",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/edit-sales-contract/{{__item._id}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openEditView",
                              "executeIf": "fn(HELPER_FN,scEditFlag,{{__item.status}})"
                            },
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openScwView",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "/view-sales-contract/{{__item._id}}",
                                "arg2Key": "openNewTab",
                                "arg2Value": "TRUE"
                              },
                              "name": "openScwView",
                              "executeIf": "fn(NOT,fn(HELPER_FN,scEditFlag,{{__item.status}}))"
                            }
                          ]
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.customer.assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "customerPO",
                          "text": "PO#"
                        },
                        {
                          "value": "__item.orders",
                          "text": "Total Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,'{{__item.type}}',===,'Sales Contract'),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantity}}),{{__item.orders}},_id)))",
                          "width": 100
                        },
                        {
                          "value": "balanceValue",
                          "text": "Balance Value",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id))"
                        },
                        {
                          "value": "balancePercent",
                          "text": "Balance %",
                          "type": "formula",
                          "formula": "fn(CONCAT,fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(DIVIDE,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.quantityLeft}}),{{__item.items}},_id),fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{__item.items}},_id)),100),true),%)"
                        },
                        {
                          "value": "__item.dateRange.startDate",
                          "text": "Contract Start",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.startDate}})"
                        },
                        {
                          "value": "__item.dateRange.endDate",
                          "text": "Contract Expiry",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.dateRange.endDate}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status",
                          "formula": "fn(HELPER_FN,qtStatus,{{__item}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve Pending QT",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Submitted Draft'),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Pending Approval'),||,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Pending Revision'))),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "approveQuotation"
                            }
                          ]
                        },
                        {
                          "label": "Approve Open QT",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'QT Successful'),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "confirmSalesContract",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/quotation/{{__item._id}}/confirm-sales-contract",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "GET",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "confirmSalesContract"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),||,fn(LOGICAL,fn(CONCAT,',{{__item.0.requests.0.type}},'),==,'Reject'))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openRejectionPopup"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingQtSearch.page",
                        "serverItemsLengthVariable": "fetchedData.pendingQts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingQtSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingQts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sales-contract/pending-quotation",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.pendingQts",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.pendingQtSearch"
                            },
                            "name": "getPendingQts"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "FG",
              "bracketValueFormula": "{{fetchedData.pendingProducts.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Products",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.pendingProducts}}",
                      "items": "fetchedData.pendingProducts.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Product #",
                          "type": "url",
                          "url": "/products/{{__item._id}}"
                        },
                        {
                          "value": "productLine",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item}})"
                        },
                        {
                          "value": "customer",
                          "text": "Customer",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdAt",
                          "text": "Created",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "updatedBy.displayName",
                          "text": "Updated By"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveProduct",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "approveProduct"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markProductAsDraft",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/product/{{__item._id}}/mark-as-draft",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "refreshPage",
                                "arg4Value": "TRUE"
                              },
                              "name": "markProductAsDraft"
                            }
                          ]
                        },
                        {
                          "label": "Disable",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markProductAsDisabled",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/product/{{__item._id}}/mark-disabled",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE"
                              },
                              "name": "markProductAsDisabled"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.productsForm.page",
                        "serverItemsLengthVariable": "fetchedData.pendingProducts.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.productsForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingProducts",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/product/search",
                              "arg2Key": "postData",
                              "arg2Value": "fetchedData.productsForm",
                              "arg3Key": "storeInVar",
                              "arg3Value": "fetchedData.pendingProducts"
                            },
                            "name": "getPendingProducts"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "CU",
              "bracketValueFormula": "{{fetchedData.pendingCustomers.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Customers",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingCustomers.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Id",
                          "type": "url",
                          "url": "/customers/{{__item._id}}"
                        },
                        {
                          "value": "__item.name",
                          "text": "Customer Name"
                        },
                        {
                          "value": "alias",
                          "text": "Alias"
                        },
                        {
                          "value": "assignedTo.displayName",
                          "text": "Assigned To"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "groups",
                          "text": "Groups",
                          "formula": "fn(HELPER_FN,joinArray,{{__item.groups}},name)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Created At",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveProspect",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer/{{__item._id}}/approve-prospect",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "fnsAfterSubmit",
                                "arg3Value": "getPendingCustomers"
                              },
                              "name": "approveProspect"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingCustomersForm.page",
                        "serverItemsLengthVariable": "fetchedData.pendingCustomers.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "name": "getPendingCustomers"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.pendingCustomersForm.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "PMT",
              "bracketValueFormula": "fn(SUM,fn(LENGTH,{{fetchedData.pendingCreditNotes.data}}),fn(LENGTH,{{fetchedData.myInvoicePayments.data}}),{{fetchedData.invoicePayments.data.totalDocs}})",
              "showIf": "fn(NOT,fn(MATCH_ROLE,Accounting | Costing))",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Credit Notes",
                      "disabled": "FALSE",
                      "showIf": "fn(LENGTH,{{fetchedData.pendingCreditNotes.data}})",
                      "items": "fetchedData.pendingCreditNotes.data",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Credit Note Id",
                          "type": "url",
                          "formula": "{{__item.typeId}}",
                          "url": "/credit-note/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "value",
                          "text": "Value",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.value}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "subtype",
                          "text": "Type"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve Selected",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveCreditNote",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v2/invoice-payment/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "storeResponse",
                                "arg3Value": "TRUE"
                              },
                              "name": "approveCreditNote"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "showApprovedCnSnackbar",
                                "type": "fnOpenSnackbar",
                                "color": "secondary",
                                "serverMessage": "Credit Note Approved, requesting ZATCA Clearance"
                              },
                              "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)",
                              "name": "showApprovedCnSnackbar"
                            },
                            {
                              "executionOrder": 3,
                              "pageFunction": {
                                "name": "clearCreditNote",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/e-invoicing/clear-invoice/{{__item._id}}?type=Credit Note",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "GET"
                              },
                              "name": "clearCreditNote",
                              "executeIf": "fn(LOGICAL,{{__response.data.typeId}},>,0)",
                            }
                          ]
                        },
                        {
                          "label": "Decline Selected",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "declineCreditNote"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "70vh"
                    }
                  ],
                  "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "My Invoice Payments",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.myInvoicePayments.data}}",
                      "items": "fetchedData.myInvoicePayments.data",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Payment Id",
                          "type": "url",
                          "url": "/invoice-payment-receipt/{{__item._id}}"
                        },
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "customerPaymentMode",
                          "text": "Mode Of Payment"
                        },
                        {
                          "value": "bankName",
                          "text": "Bank",
                          "align": "start"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "amountReceived",
                          "text": "Amount",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Edit",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openEditPaymentCollection",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "update-payment-collection",
                                "arg2Key": "queryParams",
                                "arg2Value": "{\"receipt\":\"{{__item._id}}\"}"
                              },
                              "name": "openEditPaymentCollection"
                            }
                          ]
                        },
                        {
                          "label": "Validate Payment",
                          "disableIf": "fn(LOGICAL,fn(SUM,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),!==,'Pending')),!==,0)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "validateIpr",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/invoice-payment-receipt/{{__item._id}}/submit",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "fnsAfterSubmit",
                                "arg3Value": "getMyInvoicePayments"
                              },
                              "name": "validateIpr"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true
                    }
                  ]
                },
                {
                  "name": "2",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Invoice Payments",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.invoicePayments.data.docs}}",
                      "items": "fetchedData.invoicePayments.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Payment Id",
                          "type": "url",
                          "url": "/invoice-payment-receipt/{{__item._id}}"
                        },
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "customerPaymentMode",
                          "text": "Mode Of Payment"
                        },
                        {
                          "value": "bankName",
                          "text": "Bank",
                          "align": "start"
                        },
                        {
                          "value": "status",
                          "text": "Status"
                        },
                        {
                          "value": "amountReceived",
                          "text": "Amount",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        }
                      ],
                      "tableType": "static",
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Edit",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "openEditPaymentCollection",
                                "type": "fnRedirect",
                                "arg1Key": "redirectUrl",
                                "arg1Value": "update-payment-collection",
                                "arg2Key": "queryParams",
                                "arg2Value": "{\"receipt\":\"{{__item._id}}\"}"
                              },
                              "name": "openEditPaymentCollection"
                            }
                          ]
                        },
                        {
                          "label": "Validate Payment",
                          "disableIf": "fn(LOGICAL,fn(SUM,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),!==,'Pending')),!==,0)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "validateIpr",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/invoice-payment-receipt/{{__item._id}}/submit",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "fnsAfterSubmit",
                                "arg3Value": "getInvoicePayments"
                              },
                              "name": "validateIpr"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.invoicePaymentFilters.page",
                        "itemsPerPageVariable": "fetchedData.invoicePaymentFilters.limit",
                        "serverItemsLengthVariable": "fetchedData.invoicePayments.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getInvoicePayments"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "SA",
              "bracketValueFormula": "{{fetchedData.pendingSamples.data.totalDocs}}",
              "showIf": "fn(NOT,fn(MATCH_ROLE,Accounting | Costing))",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve Pending Sample",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "disableIf": "fn(LOGICAL,fn(KEYED_ARRAY_SUM,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.status}},'),==,'Pending'),{{__item}},_id),!==,fn(LENGTH,{{__item}}))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveSample",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/sample/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "approveSample"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingSampleSearch.page",
                        "serverItemsLengthVariable": "fetchedData.pendingSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingSampleSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/pending",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.pendingSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.pendingSampleSearch"
                            },
                            "name": "getPendingSamples"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "CMP",
              "bracketValueFormula": "{{fetchedData.pendingComplaints.data.totalDocs}}",
              "showIf": "fn(NOT,fn(MATCH_ROLE,Accounting | Costing))",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Complaints",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingComplaints.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Complaint",
                          "type": "url",
                          "url": "/complaint/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.complaintType",
                          "text": "Type"
                        },
                        {
                          "value": "__item.invoice",
                          "text": "Invoice",
                          "type": "url",
                          "url": "/invoice/{{__item.invoice}}"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.defectiveQuantity",
                          "text": "Defective Quantity"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveComplaint",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "fnsAfterSubmit",
                                "arg4Value": "getPendingComplaints"
                              },
                              "name": "approveComplaint"
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copySelectedTableItem",
                                "type": "fnCopyData",
                                "arg1Key": "sourceKey",
                                "arg1Value": "__item",
                                "arg2Key": "destinationKey",
                                "arg2Value": "fetchedData.selectedComplaint",
                                "arg3Key": "destinationKeyType",
                                "arg3Value": "Object"
                              },
                              "name": "copySelectedTableItem"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openRejectionPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Reject Complaint"
                              },
                              "name": "openRejectionPopup"
                            }
                          ]
                        },
                        {
                          "label": "Hold",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "holdComplaint",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/customer-complaint/{{__item._id}}/hold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "fnsAfterSubmit",
                                "arg4Value": "getPendingComplaints"
                              },
                              "name": "holdComplaint"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingComplaintSearch.page",
                        "serverItemsLengthVariable": "fetchedData.pendingComplaints.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingComplaintSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "name": "getPendingComplaints"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "FC",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.forecastStatusData.data}})",
              "showIf": "fn(LOGICAL,{{fetchedData.forecastForm.flag}},&&,fn(NOT,fn(MATCH_ROLE,Accounting | Costing)))",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Forecasts",
                      "disabled": "FALSE",
                      "items": "fetchedData.forecastStatusData.data",
                      "showIf": "{{fetchedData.forecastStatusData.data}}",
                      "headers": [
                        {
                          "value": "customer.alias",
                          "text": "Customer",
                          "type": "url",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "url": "/customer-sales-forecast?customer={{__item.customer._id}}&year={{fetchedData.forecastForm.year}}&displaySAR=false"
                        },
                        {
                          "value": "customer.status",
                          "text": "Customer Type"
                        },
                        {
                          "value": "salesGroup.name",
                          "text": "Group"
                        },
                        {
                          "value": "salesman.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "total",
                          "text": "Forecast Value",
                          "formula": "fn(HELPER_FN,numFormat,{{__item.total}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "forecastStatus",
                          "text": "Forecast Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingComplaintSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingComplaintSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingComplaintSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingComplaintSearchForm",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Accounting | Costing))"
      },
      {
        "executionOrder": 2,
        "name": "getPendingComplaints",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Accounting | Costing))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingProductsParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingProductsParams",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productsForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingProductsParams"
      },
      {
        "executionOrder": 2,
        "name": "getPendingProducts"
      },
      {
        "executionOrder": 2,
        "name": "getPendingCreditNotes",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingQtSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingQtSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingQtSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingQtSearchForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingQts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-contract/pending-quotation",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingQts",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.pendingQtSearch"
        },
        "name": "getPendingQts"
      },
      {
        "executionOrder": 2,
        "name": "getMyInvoicePayments",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingCustomersForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingCustomersForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingCustomersForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingCustomersForm"
      },
      {
        "executionOrder": 2,
        "name": "getPendingCustomers"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getRejectionReasons",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=quotation-rejection-reasons",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.qtRejectionReasons"
        },
        "name": "getRejectionReasons"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultInvoicePaymentFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultInvoicePaymentFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.invoicePaymentFilters"
        },
        "name": "copyDefaultInvoicePaymentFilters"
      },
      {
        "executionOrder": 2,
        "name": "getInvoicePayments",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Sales | Manager),||,fn(MATCH_ROLE,General Manager))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingSampleSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingSampleSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingSampleSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingSampleSearchForm",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Accounting | Costing))"

      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getPendingSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/pending",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.pendingSampleSearch"
        },
        "name": "getPendingSamples",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Accounting | Costing))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copySalesforecastFlag&Year",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getSalesforecastFlag&Year",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.forecastForm"
        },
        "name": "copySalesforecastFlag&Year"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "loadSalesForecastStatusData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/forecast-status/generate?year={{fetchedData.forecastForm.year}}&status=Draft&status=Submitted",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.forecastStatusData"
        },
        "name": "loadSalesForecastStatusData",
        "executeIf": "fn(LOGICAL,{{fetchedData.forecastForm.flag}},&&,fn(NOT,fn(MATCH_ROLE,Accounting | Costing)))"
      }
    ],
    "functions": [
      {
        "name": "copySelectedTableItem",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedQuotation",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "approveQuotation",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/quotation/{{__item._id}}/approve",
        "arg2Key": "postData",
        "arg2Value": "{}",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE",
        "arg4Key": "serviceConfig",
        "arg4Value": "{\"service\":\"APPROVE_PRICE_CHANGE\",\"args\":[\"__item.items\"]}"
      },
      {
        "name": "openRejectionPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Reject Quotation"
      },
      {
        "name": "closeRejectionPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Reject Quotation"
      },
      {
        "name": "rejectQoutation",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/sales-contract/{{__item._id}}/request/reject",
        "arg2Key": "postData",
        "arg2Value": "fetchedData.rejectionForm",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getPendingProducts",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/product/search",
        "arg2Key": "postData",
        "arg2Value": "fetchedData.productsForm",
        "arg3Key": "storeInVar",
        "arg3Value": "fetchedData.pendingProducts"
      },
      {
        "name": "getPendingCreditNotes",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment/pending-cn",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingCreditNotes"
      },
      {
        "name": "declineCreditNote",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment/{{__item._id}}/decline",
        "arg2Key": "postData",
        "arg2Value": "{}",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getDefaultPendingQtSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getOrderId",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "fn(NUMBER,{{__selectedObject.order}})"
        },
        "useFormula": true
      },
      {
        "name": "getPendingCustomers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "fn(CONDITIONAL,fn(NOT,fn(MATCH_ROLE,SALES_ACCOUNT_EXECUTIVE)),/api/v2/customers,/api/v2/my-customers)",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingCustomers",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.pendingCustomersForm"
      },
      {
        "name": "getMyInvoicePayments",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/my-invoice-payment-receipts?status=Pending&status=Submitted",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.myInvoicePayments"
      },
      {
        "name": "getInvoicePayments",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment-receipts?status=Submitted&status=Pending",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.invoicePayments",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.invoicePaymentFilters"
      },
      {
        "name": "getDefaultPendingCustomersForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "paginate": true,
          "limit": 50,
          "status": ["Pending Prospect"]
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPendingProductsParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Pending"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultInvoicePaymentFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPendingSampleSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPendingComplaintSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Pending"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getPendingComplaints",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/customer-complaint/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.pendingComplaints",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.pendingComplaintSearch"
      },
      {
        "name": "getSalesforecastFlag&Year",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "flag": "fn(FEATURE_FLAG,Sales Forecast)",
          "year": "{{FORECAST_YEAR}}"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,ACCOUNTING_COSTING,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 100
}